import React from "react";
import "../../Styles/customManage.css";
import nfc_city from "../../Assets/4394545_3169-removebg.png";
export default function CustomManaging() {
  return (
    <div className="custom_Managing">
      <div className="custom_Managing_wrapper">
        <div className="M_top">
          <div className="topContent">
            <div className="M_leftborder"></div>
            <div className="tophead">CUSTOMISING AND MANAGING</div>
            <div className="toptext">
              <div>
                Customizing a website involves tailoring its design,
                functionality, and features to meet{" "}
              </div>
              <div>
                the specific needs and preferences of a client or target
                audience.This process goes{" "}
              </div>
              <div>
                beyond using generic templates and involves creating a unique
                and branded online{" "}
              </div>
              <div>
                vexperience. Key aspects of customizing websites include:
              </div>
            </div>
            <div className="M_rightborder"></div>
          </div>
        </div>
        <div className="M_footer">
          <div className="M_footer_wrappre">
            <div className="M_inner_wrapper">
              <div className="M_footer_top"></div>
              <div>Managing a website involves ongoing tasks to ensure</div>
              <div>its smooth operation, security, and relevance.</div>
              <div>Effective website management contributes to a positive</div>
              <div>user experience and helps the site achieve its goals.</div>
              <div className="M_footer_bottom"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="M_img">
        <img src={nfc_city} alt="" className="M_img" />
      </div>
    </div>
  );
}
